import { Link, useHistory } from "react-router-dom";

import HeaderWebb from "../comp/head-navs-webb";
import ViewContent from "../comp/view-content";

import WebbDemoListModule from "../comp/webb-demo-list";

const avtr = [
  "https://img.freepik.com/free-photo/brainstorm-meeting_1098-15871.jpg?size=626&ext=jpg",
  "https://img.freepik.com/free-photo/young-collage-student-using-computer-mobile-device-studying-online-education-online-learning_1421-4504.jpg?size=626&ext=jpg",
  "https://img.freepik.com/free-vector/isometric-people-working-with-technology_52683-19078.jpg?size=626&ext=jpg",
]

export default function Land() {

  const history = useHistory();


  return (
    <>
    <HeaderWebb/>


    <div className="layout-featured">
      <img src={avtr[0]} alt='' className="img-fluid w-100"></img>
    </div>
    <div className="bg-white" style={{height:'60vh'}}>
      <ViewContent 
        content= {
          <>
            <div className="py-3 text-center">
            <p className="caption-md fw-bold text-primary">
              {process.env.REACT_APP_WEBB_SITE_NAME}
            </p>
            <p className="lead">{process.env.REACT_APP_WEBB_SITE_LINE}</p>
            </div>

          </>
        }
      />

    </div>
    </>
  )
}